import { render, staticRenderFns } from "./TrinityRings.vue?vue&type=template&id=c838daa6&scoped=true"
import script from "./TrinityRings.vue?vue&type=script&lang=js"
export * from "./TrinityRings.vue?vue&type=script&lang=js"
import style0 from "./TrinityRings.vue?vue&type=style&index=0&id=c838daa6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c838daa6",
  null
  
)

export default component.exports